import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { TokenService } from 'src/app/services/token/token.service';

@Component({
  selector: 'app-brand-selection',
  templateUrl: './brand-selection.component.html',
  styleUrls: ['./brand-selection.component.scss']
})
export class BrandSelectionComponent implements OnInit, OnDestroy {
  @Output() readonly selectBrand = new EventEmitter<any>();
  brandList: any[] = [];
  readonly brandInputCtrl = new UntypedFormControl();
  private subscription: Subscription;

  constructor(
    private tokenServe: TokenService,
    private profileServe: ProfileService,
  ) {
    this.subscription = this.brandInputCtrl.valueChanges.subscribe((value: string) => {
      const selectedBrand = this.brandList.find(b => b.id === value);
      this.selectBrand.emit(selectedBrand);
    });
  }

  async getBrandList(): Promise<void> {
    try {
      const data = await this.profileServe.getBrandsByBusiness();
      data.map((x: any) => {
        if (x.isActive) {
          this.brandList.push(x);
        }
      })
      console.log(this.brandList, 'brand list');
      this.brandInputCtrl.setValue(this.brandList[0]?.id || '');
      // this.selectBrand.emit(this.brandList[0]);
    } catch (error) {
      console.log(error)
    }
  }

  ngOnInit(): void {
    this.getBrandList();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}
